import { normalizeBuyerIntentId, normalizeBuyerIntentIds } from './idNormalization'

export const BUYER_INTENT_DEFAULT_COUNTRY_CODE = 'US'

const COUNTRY_CODE_RE = /^[A-Z]{2}$/

const getHeaderValue = value => {
  if (Array.isArray(value)) {
    return value[0]
  }

  return value
}

export const normalizeBuyerIntentCountryCode = value => {
  const normalizedValue = String(getHeaderValue(value) || '')
    .trim()
    .toUpperCase()

  if (!COUNTRY_CODE_RE.test(normalizedValue)) {
    return BUYER_INTENT_DEFAULT_COUNTRY_CODE
  }

  return normalizedValue
}

export const getBuyerIntentCountryCodeFromHeaders = headers =>
  normalizeBuyerIntentCountryCode(headers?.['x-geo-country-code'] || headers?.['cf-ipcountry'])

export const getBuyerIntentCategoryId = appData =>
  normalizeBuyerIntentId(appData?.head?.data_layer?.[0]?.categoryPageUuid)

const getEntityBuyerIntentProductId = entity =>
  normalizeBuyerIntentId(entity?.id) || normalizeBuyerIntentId(entity?.global_product_id)

export const getBuyerIntentProductId = ({ appData, listing, product, productId } = {}) =>
  normalizeBuyerIntentId(productId) ||
  getEntityBuyerIntentProductId(product) ||
  getEntityBuyerIntentProductId(listing) ||
  normalizeBuyerIntentId(appData?.head?.data_layer?.[0]?.globalProductId)

export const getBuyerIntentListingProductIds = listings => [
  ...new Set(normalizeBuyerIntentIds(listings?.map(listing => getEntityBuyerIntentProductId(listing)))),
]

export const getBuyerIntentCompareProductIds = compareData => {
  const productIds = normalizeBuyerIntentIds(
    compareData?.listings?.map(listing => getEntityBuyerIntentProductId(listing))
  )

  if (productIds.length < 2) {
    return []
  }

  return productIds
}

export const warnMissingBuyerIntentIds = (surface, details = {}) => {
  if (['production', 'test'].includes(process.env.NODE_ENV)) {
    return
  }

  // eslint-disable-next-line no-console -- Development-only instrumentation warnings help surface missing UUID coverage
  console.warn('[buyer-intent] Missing or invalid identifiers for surface:', surface, details)
}
